import { memo } from 'react';

import { OButton, OCheck, OTextArea } from '@src/shared';
import AvatarCircle from '@src/components/AvatarCircle';

import useAskQuestion from './useAskQuestion';

import { FaPlus } from 'react-icons/fa';
import { CgClose } from 'react-icons/cg';

import styles from './askQuestion.module.scss';

const AskQuestion = () => {
  const {
    author,
    questionText,
    isAskAnonymously,
    isQuestionBoxOpened,
    isAskQuestionDisabled,
    isPostQuestionDisabled,
    isAskAnonymouslyEnabled,

    isEditQuestionDisabled,
    questionToEdit,
    maxAllowedQuestions,
    handlePostQuestion,
    handleChangeQuestion,
    handleQuestionKeyDown,
    handleAnonymouslyCheck,
    handleCloseAskQuestion,
    handleAskQuestionClick,
    formattedTime,
    isAskAnonymouslySettings,
  } = useAskQuestion();

  if (!isQuestionBoxOpened) {
    return (
      <div className={styles.askQuestionButtonContainer}>
        <OButton
          text="Ask a Question"
          size="full"
          isDisabled={isAskQuestionDisabled}
          toolTipContent={isAskQuestionDisabled ? 'you reached maximum number of questions' : ''}
          startIcon={<FaPlus size={20} />}
          onClick={handleAskQuestionClick}
        />

        <span className={styles.label}>You’re allowed to submit a maximum of {maxAllowedQuestions} questions</span>
      </div>
    );
  }
  return (
    <div className={styles.askQuestionBox}>
      {questionToEdit && (
        <div className={styles.editQuestionContainer}>
          <div className={styles.editQuestionHeader}>
            <p className={styles.editQuestionTitle}>Edit Question</p>
            <button className={styles.editQuestionCloseButton} onClick={handleCloseAskQuestion}>
              <CgClose size={15} color={'black'} />
            </button>
          </div>
          <div className={styles.editQuestionContent}>
            <div className={styles.editQuestionContentHeader}>
              <AvatarCircle peerId={author ? questionToEdit.creator.id : ''} name={author ?? 'AN'} avatarImgSize={36} />
              <p className={styles.editQuestionContentName}>{questionToEdit?.creator?.name}</p>
            </div>
            <p className={styles.editQuestionContentTime}>{formattedTime}</p>
          </div>
        </div>
      )}
      <OTextArea
        maxLength={400}
        value={questionText}
        textAreaHeight="medium"
        placeholder="Write your question here"
        onKeyDown={handleQuestionKeyDown}
        onChange={handleChangeQuestion}
      />
      <div className={styles.askQuestionBoxActionsContainer}>
        {isAskAnonymouslyEnabled && isAskAnonymouslySettings && (
          <OCheck
            className={questionToEdit ? styles.disableAskAnonymously : ''}
            checked={isAskAnonymously}
            disabled={!!questionToEdit}
            onChange={handleAnonymouslyCheck}
            label="Post anonymously"
          />
        )}
        <div className={styles.buttonsContainer}>
          {!questionToEdit && (
            <OButton text="Cancel" variant="primary" size="auto" outlined onClick={handleCloseAskQuestion} />
          )}
          <OButton
            text={questionToEdit ? 'Edit' : 'Post'}
            size="auto"
            variant="alternative"
            isDisabled={isPostQuestionDisabled || isEditQuestionDisabled}
            onClick={handlePostQuestion}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(AskQuestion);
